<template src="@/templates/sidenav/sideNav.html"></template>

<script>
import UpdateAvailability from "@/components/availability/UpdateAvailability";
import TransitionLetter from "@/components/document/TransitionLetter";
import TransitionLetterModel from "@/models/transitionLetterModel";
import BookingCountModel from "@/models/bookingCountModel";
import PolicyDocumentsModel from "@/models/policyDocumentsModel";
import ResourceModel from "@/models/resourceModel";
import ClearanceCheckCollection from "@/collections/clearanceCheckCollection";
import JobActivityReportCollection from "@/collections/jobActivityReportCollection";
import SocialMedia from "@/components/socialMedia";

import { mapState, mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState(["sideNav", "jwt", "availability"]),
    ...mapGetters(["full_name"]),
    sideNavActive: {
      get: function () {
        return this.sideNav.active;
      },
      set: function (newValue) {
        this.toggleSideNav(newValue);
      },
    },
    isLoggedIn: {
      get: function () {
        if (localStorage.getItem("jwt")) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  components: {
    UpdateAvailability,
    TransitionLetter,
    SocialMedia,
  },
  watch: {
    sideNavActive: {
      handler: function () {
        if (this.sideNavActive) {
          this.getBookingCount();
          this.getPolicyDocumentsReadCount();
          this.getResourceMenu();
          this.getClearanceCheckMenu();
          this.getUnreadPaymentsCount();
        }
      },
    },
  },
  data() {
    return {
      sideNavComponentKey: 0,
      viewTransitionLetter: false,
      transitionLetterModel: new TransitionLetterModel(),
      bookingCountModel: new BookingCountModel(),
      policyDocumentsModel: new PolicyDocumentsModel(),
      resourceModel: new ResourceModel(),
      clearanceCheckCollection: new ClearanceCheckCollection(),
      jobActivityReportCollection: new JobActivityReportCollection(),
      jwtToken: localStorage.getItem("jwt"),
      unreadPaymentsCount: "",
    };
  },
  mounted() {
    Event.$on("tokenExpiredLogout", () => {
      this.loggedOut();
    });

    Event.$on("hideTransitionLetterComp", (sendEmailStatus) => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.viewTransitionLetter = false;
        thisComponent.navigateTo("profile");
      }, 50);

      if (sendEmailStatus) {
        this.$vs.loading({
          type: "material",
        });

        this.transitionLetterModel
          .sendLetter()
          .then((TLModelRes) => {
            let res = TLModelRes.response.data;

            if (res.error !== false) {
              this.sendError(res.error);
            } else {
              this.sendSuccess();
            }

            this.$vs.loading.close();
          })
          .catch((STLError) => {
            let errorMessage = "Network error. " + STLError;
            this.sendError(errorMessage);
          });
      }
    });
  },
  methods: {
    ...mapActions([
      "resetState",
      "updateAvailability",
      "toggleSideNav",
      "updateSearchedDate",
      "updateResourceDetailPgTitle",
    ]),

    createBadgeForGroupMenu(type, total, customStyle) {
      let badge = document.getElementById(type + "Badge");
      if (badge) {
        badge.remove();
      }

      if (total > 0) {
        let groupMenu = document.getElementById(type + "GroupMenu").firstChild;
        let lastNode = document.getElementById(type + "GroupMenu").firstChild
          .childNodes[1];

        let elSpan = document.createElement("span");
        elSpan.innerHTML = total;
        elSpan.style.position = "absolute";
        elSpan.style.marginLeft = customStyle.marginLeft;
        elSpan.style.top = "5px";
        elSpan.style.backgroundColor = "#D47630";
        elSpan.style.borderRadius = "8px";
        elSpan.style.color = "#DCE0E1";
        elSpan.style.fontSize = "75%";
        elSpan.style.padding = "2px 4px 2px 4px";
        elSpan.setAttribute("id", type + "Badge");
        groupMenu.insertBefore(elSpan, lastNode);
      }
    },
    navigateTo(route) {
      this.updateAvailability(false); // calling store
      this.updateSearchedDate();
      this.sideNavActive = !this.sideNav.active;

      /** This delay is required to make sure store has been updated before router navigation*/
      let thisComp = this;
      setTimeout(function () {
        thisComp.$router.push({ path: "/" + route.split(" ").join("") });
      }, 5);
    },
    showAvailability() {
      this.updateAvailability(true);
      this.sideNavActive = !this.sideNav.active;
    },
    triggerLetter() {
      this.viewTransitionLetter = true;
    },
    sendError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    closeSideNav() {
      this.sideNavActive = false;
    },
    sendSuccess() {
      this.closeSideNav();
      this.$vs.notify({
        title: "Email sent",
        text:
          "Your requested NAATI recertification Letter has been emailed to " +
          localStorage.getItem("interpreterEmail"),
        time: 4000,
        color: "success",
        position: "top-center",
      });
    },
    getBookingCount() {
      this.bookingCountModel
        .getBookingCount()
        .then((res) => {
          console.log(this.bookingCountModel);
          let result = res.response.data;
          if (result) {
            this.bookingCountModel.available = result.available;
            this.bookingCountModel.available_onsite = result.available_onsite;
            this.bookingCountModel.available_telephone =
              result.available_telephone;
            this.bookingCountModel.available_video = result.available_video;
            this.bookingCountModel.today = result.today;
            this.bookingCountModel.confirmed = result.confirmed;
            this.bookingCountModel.total =
              result.available + result.today + result.confirmed;
            if (this.bookingCountModel.total) {
              let customStyle = {
                marginLeft: "75px",
              };

              this.createBadgeForGroupMenu(
                "booking",
                this.bookingCountModel.total,
                customStyle
              );
              this.createBadgeForGroupMenu(
                "available",
                this.bookingCountModel.available,
                customStyle
              );
            }
          }
          console.log(result);
        })
        .catch((error) => {
          debugger;
          console.log(error);
        });
    },
    getUnreadPaymentsCount() {
      this.jobActivityReportCollection
        .getUnreadPaymentsCount()
        .then((res) => {
          this.unreadPaymentsCount = res.response.data.unread_count;
        })
        .catch((error) => {
          debugger;
          console.log(error);
        });
    },
    getPolicyDocumentsReadCount() {
      this.policyDocumentsModel
        .getPDReadCount()
        .then((res) => {
          this.policyDocumentsModel.dbData.unreadCount =
            res.response.data.unread;
        })
        .catch((error) => {
          debugger;
          console.log(error);
        });
    },
    getResourceMenu() {
      this.resourceModel
        .getResourceMenu()
        .then((res) => {
          this.resourceModel.dbData = res.response.data;

          /** Total unread/unseen resources **/
          let totalURS =
            parseInt(this.resourceModel.dbData[0].total_resources) -
            parseInt(this.resourceModel.dbData[0].total_read);
          let customStyle = {
            marginLeft: "80px",
          };

          this.createBadgeForGroupMenu("resource", totalURS, customStyle);
        })
        .catch((error) => {
          // debugger;
          console.log(error);
        });
    },
    getClearanceCheckMenu() {
      this.clearanceCheckCollection
        .getMenuList()
        .then((res) => {
          this.clearanceCheckCollection.models = res.response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loggedOut() {
      this.sideNavActive = !this.sideNav.active;
      localStorage.removeItem("jwt");
      localStorage.removeItem("interpreterId");
      localStorage.removeItem("interpreterFirstName");
      localStorage.removeItem("interpreterLastName");
      localStorage.removeItem("interpreterAddress");
      localStorage.removeItem("interpreterSuburb");
      localStorage.removeItem("interpreterPostCode");
      localStorage.removeItem("interpreterPhone");
      localStorage.removeItem("interpreterMobile");
      localStorage.removeItem("interpreterEmail");
      localStorage.removeItem("itProjectId");
      localStorage.removeItem("interpreterLanguages");
      localStorage.removeItem("fmInterpreterId");
      localStorage.removeItem("staffLogin");
      this.resetState();
      this.sideNavComponentKey = this.sideNavComponentKey + 1;
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  position: relative;
  border-radius: 0%;
  color: white;
  margin-top: 0px;
  margin-left: 8px;
  background-color: #f57e21;
  font-weight: 300;
  padding: 0.25em 0.4em;
}

#bookingBadge #resourceBadge {
  position: relative;
  border-radius: 0%;
  color: white;
  margin-top: 0px;
  margin-left: 8px;
  background-color: #f57e21;
  font-weight: 300;
  padding: 0.25em 0.4em;
}
</style>
